module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a7-7-d5d39ef3dd2bc5275998f1d3c4d61ea0.jpg";